import React, { useEffect } from 'react';
import { change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { ArmiesAction, ModelRulesAction, VersionsAction } from '@Redux/actions';
import SearchModelRuleForm from './SearchModelRuleForm';
import Repeater from '@Utils/Repeater';
import { ModelRuleSearchPresenter } from '@Selectors/searchModelRule/make/ArmyListSearchPresenter';
import { EntityId, TypeRule, UnitCaracType } from '@Models';
import { UnitView } from '@Selectors/searchModelRule/make/view/UnitView';
import UnitTypeView from '../../myArmyList/make/unit/show/UnitTypeView';
import UnitV1Profil from '../../myArmyList/make/unit/show/UnitV1Profil';
import UnitGlobalProfil from '../../myArmyList/make/unit/show/UnitGlobalProfil';
import UnitDefenseProfil from '../../myArmyList/make/unit/show/UnitDefenseProfil';
import UnitOffensiveProfil from '../../myArmyList/make/unit/show/UnitOffensiveProfil';
import { SearchModelRuleParams } from './validate';
import { UnitRepository } from '@Repository/ninthAge';
import { RequestUnitsSuccess } from '@Repository/ninthAge/response';
import {
  ModelRuleView,
  TroopProfilView
} from '@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View';
import { UnitCaracView } from '@Selectors/builder/myArmyList/make/unit/show/view/UnitCaracView';

const SearchMake: React.FC<SearchMakeProps> = ({
                                                 loadVersions,
                                                 loadArmies,
                                                 loadRules,
                                                 datas,
                                                 units,
                                                 onBasicFieldChange,
                                                 handleOnSelect,
                                                 handleSubmit
                                               }) => {
  useEffect(() => {
    loadVersions();
    loadArmies();
  }, []);

  return (
    <section className="mt-2 text-center">
      <div>
        {datas.isLoading && <div className="loader" />}
        {!datas.isLoading &&
          <SearchModelRuleForm versions={datas.versions} armies={datas.armies} loadRules={loadRules}
                               handleOnSelect={handleOnSelect}
                               onSubmit={handleSubmit} canSubmit={datas.canSubmit} onChange={onBasicFieldChange} />}
      </div>
      <div>
        <div className="content row justify-content-center">
          <Repeater data={units} indexPrefix="army-list">
            {
              (item: UnitView) =>
                <section className="m-5 row">
                  <div className="col-12 col-md-4">
                    {/*{false && <OrganisationView organisations={item.organisationIds}/>}*/}
                  </div>
                  <div className="col-12 col-md-4">
                    {item.name}
                  </div>
                  <div className="col-12 col-md-4">
                    <UnitTypeView height={item.carac.height} type={item.carac.unitType} base={item.carac.base} />
                  </div>
                  {item.isV1 && <UnitV1Profil troops={item.troops} />}
                  {item.isV2 &&
                    <UnitGlobalProfil armyListUnitId={''} carac={item.carac} modelRules={item.modelRuleUnitTroops} />}
                  {item.isV2 &&
                    <UnitDefenseProfil armyListUnitId={''} carac={item.carac} modelRules={item.modelRuleUnitTroops} />}
                  {item.isV2 &&
                    <UnitOffensiveProfil armyListUnitId={''} troops={item.troops} />}
                </section>
            }
          </Repeater>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state: AppState) => {
  const selector = formValueSelector('search_special_rule');
  return {
    datas: ModelRuleSearchPresenter(state),
    units: selector(state, 'units') ?? new Array<UnitView>()
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armiesAction = container.get<ArmiesAction>(TYPES.Actions.ArmiesAction);
  const versionsAction = container.get<VersionsAction>(TYPES.Actions.VersionsAction);
  const specialRulesAction = container.get<ModelRulesAction>(TYPES.Actions.ModelRulesAction);
  const repository = container.get<UnitRepository>(TYPES.Repository.UnitRepository);
  return {
    loadVersions: () => dispatch(versionsAction.fetchData()),
    loadArmies: () => dispatch(armiesAction.fetchData()),
    onBasicFieldChange: (event: any, newValue: any, previousValue: any, name: any) => {
      if (name === 'versionId')
        dispatch(specialRulesAction.search({ versionId: newValue }));
      else if (name === 'armyIds')
        dispatch(specialRulesAction.search({ armyIds: newValue }));
    },
    loadRules: ({ versionId, armyIds }: { versionId: number, armyIds: Array<number> }) =>
      dispatch(specialRulesAction.search({ versionId: versionId, armyIds: armyIds })),
    handleOnSelect: (item: EntityId<number>) =>
      dispatch(change('search_special_rule', 'modelRuleId', item.id)),
    handleSubmit: (values: SearchModelRuleParams) => {
      repository.seach(values)
        .then(response => {
          if (response instanceof RequestUnitsSuccess) {
            const units = (response as RequestUnitsSuccess).payload.map(item => {

              const unitModelRules = item.modelRuleUnitTroops.filter(rule => !rule.troopId)
                .map(rule => new ModelRuleView(
                  {
                    id: rule.modelRuleId,
                    typeLvl: rule.typeLvl,
                    type: TypeRule.Equipment,
                    name: rule.name,
                    description: rule.description,
                    armyListUnitModelRuleId: null,
                    checkable: false,
                    checked: false
                  })
                );

              return new UnitView({
                id: item.id,
                name: item.name,
                organisationIds: item.allOrganisationIds,
                carac: new UnitCaracView({
                  type: item.carac.type,
                  adv: item.carac.ground_adv,
                  mar: item.carac.ground_mar,
                  dis: item.carac.dis,
                  evoked: item.carac.evoked,
                  hp: item.carac.hp,
                  def: item.carac.def,
                  res: item.carac.res,
                  arm: item.carac.arm,
                  aeg: item.carac.aeg,
                  flyAdv: item.carac.fly_adv,
                  flyMar: item.carac.fly_mar,
                  unitType: '',
                  base: item.carac.unitBase.name,
                  height: item.carac.unitHeight.name,
                }),
                troops: item.troops.map(troop => {
                  const troopCarac = troop.carac;
                  return new TroopProfilView({
                    name: troop.name,
                    carac: troopCarac,
                    modelRules: item.modelRuleUnitTroops
                      .filter(rule => rule.troopId == null || rule.troopId === item.id)
                      .map(rule => new ModelRuleView(
                        {
                          id: rule.modelRuleId,
                          typeLvl: rule.typeLvl,
                          type: rule.typeRule,
                          name: rule.name,
                          description: rule.description,
                          armyListUnitModelRuleId: null,
                          checkable: false,
                          checked: false
                        })
                      )
                  });
                }),
                modelRuleUnitTroops: unitModelRules,
                isV1: item.carac.type == UnitCaracType.V1,
                isV2: item.carac.type == UnitCaracType.V2
              });
            });
            dispatch(change('search_special_rule', 'units', units));
          }
        });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchMake);

type SearchMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
